import React, { useContext, useEffect, useState } from "react";
import TvLockIcon from "../../assets/icons/svg/TvLockIcon";
import { defaultProfileAvatar } from "../../statics/config";
import localizationStrings from "../../statics/localization";
import addProfileIcon from "../../assets/images/add-profile-button.png";
import { SessionContext } from "../../context/SessionContext";
import PencilIcon from "../../assets/icons/svg/PencilIcon";
import { normalizeApiText } from "../../utils/charset";
import { getProfileCopy } from "../profileSettings/profileCopy";

const ProfileItem = ({
  item,
  onSelection,
  currentProfile,
  isFromProfileLogin,
  count,
  onEditClick,
  isEditing
}) => {
  const copy = getProfileCopy();
  const [avatar, setAvatar] = useState("");
  const [showSettingsIcon, setShowSettingsIcon] = useState(false);

  useEffect(() => {
    if (item.kid) {
      item.photo = "kids" + item.photo;
    }
    item.posterimage = item?.avatar || defaultProfileAvatar;
    setAvatar(item.posterimage);
    if (item.id == -1) {
      setShowSettingsIcon(false);
    } else {
      if (currentProfile?.main || item.id === currentProfile?.id) {
        setShowSettingsIcon(true);
      }
    }
  }, [item]);

  return (
    // The active class is large but incorrect. When hovered over, it will be large.
    <div
      className={`profile-item${
        item?.id === currentProfile?.id ||
        (isFromProfileLogin && item?.id == -1)
          ? " active"
          : ""
      }`}
    >
      {/* style={{ width: `${100 / count}vw` }} */}
      <button
        type="button"
        aria-label={`${
          isEditing ? localizationStrings.editProfile + ": " : ""
        }${normalizeApiText(item.name)}`}
        className="profile-avatar"
        onClick={() => {
          if (isEditing) {
            onEditClick(item);
          } else {
            onSelection(item);
          }
        }}
      >
        {item.id == -1 ? (
          <div
            className={`plus-border${isFromProfileLogin ? " b-flamingo" : ""}`}
          >
            <svg
              className="profile-add-icon"
              viewBox="0 0 24 24"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M12 4v16M4 12h16" />
            </svg>
          </div>
        ) : (
          <img
            // className={`border ${
            //   item?.id === currentProfile?.id ? "b-flamingo" : ""
            // }`}
            src={avatar}
            alt=""
            onError={() => setAvatar(defaultProfileAvatar)}
          />
        )}
        {item?.hasPin ? (
          <div className="settings-icon-wrapper">
            <div className="settings-icon">
              <TvLockIcon />
            </div>
          </div>
        ) : null}
      </button>
      {isEditing && item?.id !== -1 ? (
        <div className="pencil-icon">
          <PencilIcon />
        </div>
      ) : null}
      <div
        className={`profile-name${item?.id == -1 ? " chakra" : ""}${
          item?.id === currentProfile?.id ? " selected" : ""
        }`}
        style={{ width: `100%` }}
        title={normalizeApiText(item.name)}
      >
        {normalizeApiText(item.name)}
      </div>
      {item.id !== -1 && (
        <span className="profile-kind">
          {item.id === currentProfile?.id
            ? copy.active
            : item.kid
            ? copy.kids
            : copy.profile}
        </span>
      )}
      {/* {!isFromProfileLogin && showSettingsIcon ? (
        <div className="edit-text" onClick={() => onEditClick(item)}>
          {localizationStrings.editProfile}
        </div>
      ) : null} */}
    </div>
  );
};

export default ProfileItem;
